"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTargetAggregate = void 0;
const client_1 = require("@apollo/client");
const configContext_1 = require("../contexts/configContext");
const graphql_1 = require("../utils/graphql");
const aggregate_1 = require("../utils/aggregate");
const useTargetAggregate = (aggregateType, aggregateId) => {
    const { aggregateDefinitions } = (0, configContext_1.useConfig)();
    const aggregateDefinition = aggregateDefinitions.find(d => d.name === aggregateType);
    const aggregateTypeName = (aggregateDefinition === null || aggregateDefinition === void 0 ? void 0 : aggregateDefinition.queryKey) || '';
    const aggregateIds = Array.isArray(aggregateId) ? aggregateId : [aggregateId];
    const { data, loading, error, refetch } = (0, client_1.useQuery)((0, client_1.gql) `
      query AssetData($aggregateIds: [UUID!]!) {
        ${aggregateTypeName}(filter: {id: {in: $aggregateIds}}) {
          id
          label
          assetAttributes
          modifiedDateTime
          ${(0, graphql_1.getAggregateDataFields)(aggregateDefinition)}
        }
      }
    `, {
        skip: !aggregateIds.length,
        variables: { aggregateIds },
        fetchPolicy: 'cache-and-network',
    });
    let record;
    if (data && data[aggregateTypeName]) {
        if (Array.isArray(aggregateId)) {
            record = data[aggregateTypeName].map(agg => (0, aggregate_1.graphqlToAssetTransform)({ flattenRelationships: true, result: agg, aggDef: aggregateDefinition }));
        }
        else {
            record = (0, aggregate_1.graphqlToAssetTransform)({
                flattenRelationships: true,
                result: data[aggregateTypeName][0],
                aggDef: aggregateDefinition,
            });
        }
    }
    return {
        loading,
        error,
        refetch,
        record,
    };
};
exports.useTargetAggregate = useTargetAggregate;
//# sourceMappingURL=useTargetAggregate.js.map